import { useDialogStore } from "@/shared/stores";
import { Button } from "@spz/ui/components/button";
import { useTranslation } from "react-i18next";
import { RoleForm } from "../forms/role-form";

export const useUpsertRoleDialog = () => {
  const { openDialog, closeDialog } = useDialogStore();
  const { t } = useTranslation();

  return {
    open: ({ roleId }: { roleId?: string }) => {
      const buttonText = roleId ? t("validate") : t("create");

      openDialog({
        header: {
          title: t("role_management_title"),
        },
        content: (
          <RoleForm
            className="max-h-[70vh] overflow-y-auto overscroll-y-auto overflow-x-hidden pink-scroll"
            roleId={roleId}
            onSuccess={closeDialog}
          />
        ),
        footer: {
          actions: (
            <Button type="submit" form="role-form">
              {buttonText}
            </Button>
          ),
        },
      });
    },
  };
};
